import Marquee from "react-fast-marquee";

export default function EditorialMarquee() {
  const items = ["Safe Assets", "Safe Nature", "Verify & Buy", "Secure Your Future"];
  return (
    <section data-testid="marquee-section" className="bg-ov-greenPale py-10 border-y border-ov-navy/10 overflow-hidden">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((t, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display text-5xl md:text-7xl lg:text-8xl text-ov-navy px-8">
              {t}
            </span>
            <span className="text-ov-green text-4xl md:text-6xl">•</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
}
